import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const PencilIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' ref={ref} {...props}><path d='m9.4 6 .6.6-6 6h-.7v-.5l6-6.1Zm2.4-4c-.2 0-.4 0-.5.2l-1.2 1.2L12.6 6l1.2-1.2c.3-.3.3-.7 0-1l-1.6-1.5a.7.7 0 0 0-.4-.2ZM9.4 4.1 2 11.5V14h2.5l7.4-7.4-2.5-2.5Z' fill='currentColor'/></svg>
));

